export default "__VITE_ASSET__9cbc43fb__"